<template>
  <div id="index" class="index-wrapper" ref="indexViewBox">
    <!-- <banner class="hidden-sm-and-down"></banner> -->
    <banner></banner>

    <query class="hidden-sm-and-down"></query>
    <!-- 移动端搜索框 start -->
    <div class="mIndex-search-wrapper hidden-md-and-up">
      <input type="text" placeholder="搜索职位" v-model="searchVal">
      <p class="searchIcon" @click="enterEventSearch"></p>
    </div>
    <!-- 移动端搜索框 end -->

    <hotjob class="hidden-sm-and-down"></hotjob>
    <m-hotjob class="hidden-md-and-up"></m-hotjob>

    <fradvantage class="hidden-sm-and-down"></fradvantage>
    <fradvantage :mFRadvantage="mFRadvantage" class="hidden-md-and-up"></fradvantage>

    <hfadvantage class="hidden-sm-and-down"></hfadvantage>

    <process class="hidden-sm-and-down"></process>
    <m-process class="hidden-md-and-up"></m-process>

    <information class="hidden-sm-and-down"></information>
    <m-partners class="hidden-md-and-up"></m-partners>

    <cases class="hidden-sm-and-down"></cases>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      mFRadvantage: "mFRadvantage-wrapper",
      searchVal: null
    };
  },
  components: {
    banner: resolve => {
      require(["./banner.vue"], resolve);
    },
    query: resolve => {
      require(["./query.vue"], resolve);
    },
    hotjob: resolve => {
      require(["./hotJobs.vue"], resolve);
    },
    fradvantage: resolve => {
      require(["./FRadvantage.vue"], resolve);
    },
    hfadvantage: resolve => {
      require(["./HFadvantage.vue"], resolve);
    },
    process: resolve => {
      require(["./process.vue"], resolve);
    },
    information: resolve => {
      require(["./information.vue"], resolve);
    },
    cases: resolve => {
      require(["./case.vue"], resolve);
    },

    // 移动端
    mHotjob: resolve => {
      require(["./mHotJob.vue"], resolve);
    },
    mProcess: resolve => {
      require(["./mProcess.vue"], resolve);
    },
    mPartners: resolve => {
      require(["./mPartners.vue"], resolve);
    }
  },
  methods: {
    // 回车搜索事件
    enterEventSearch() {
      if (this.searchVal != null) {
        this.$router.push({
          name: "recruitIndex",
          query: { searchJob: this.searchVal }
        });
      } else {
        this.$router.push("recruitIndex");
      }
    }
  }
};
</script>

<style lang="less">

.share-mTitle {
  position: relative;
  margin-bottom: 0.23rem;
  span {
    display: inline-block;
    position: relative;
    padding-left: 0.17rem;
    font-size: 0.18rem;
    line-height: 1;
    color: #000000;
    font-weight: bolder;
    i {
      position: absolute;
      top: 5%;
      left: 0;
      display: inline-block;
      width: 0.025rem;
      height: 100%;
      background-color: #0f8ffd;
    }
  }
}
.mIndex-search-wrapper {
  position: relative;
  padding: 0.1rem 0.175rem;
  border-bottom: 0.1rem solid #e9e9e9;
  input {
    // padding: 0.1rem 0.1rem 0.1rem 0.6rem;
    padding: 0.1rem;
    width: 100%;
    border: 1px solid #dcdcdc;
    border-radius: 5px;
    font-size: 0.16rem;
    color: #333333;
  }
  .searchIcon {
    position: absolute;
    top: 50%;
    right: .175rem;
    z-index: 2;
    width: .6rem;
    height: .4rem;
    background: url("../../../../static/images/m/searchIcon.png") no-repeat center;
    background-size: 0.2rem auto;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
  }
  ::placeholder {
    color: #878787;
  }
}

.share-content-1200{
  width: 62.5%;
  margin: 0 auto;
}
@media screen and (max-width: 1680px){
  .share-content-1200{
    width: 72.5%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1440px){
  .share-content-1200{
    width: 82.5%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/index/index.vue